// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FindUs_wrapper__4NQTE {
  margin-bottom: 60px;
  background-color: #f5f5f5;
  border-radius: 16px;
  display: grid;
  grid-template-columns: 1.5fr 2.6fr;
  grid-template-rows: 0.4fr 1fr;
  padding: 50px;
  padding-left: 120px;
  box-sizing: border-box;
}

.FindUs_title__x\\+uGp {
  grid-column: 1/2;
  grid-row: 1/2;
  padding-left: 60px;
}

.FindUs_h3__uXsOu {
  font-size: 20px;
  color: rgb(188, 188, 188);
}

.FindUs_h1__eBs6r {
  font-size: 36px;
  font-weight: 800;
  font-family: "Lato";
}

.FindUs_left__juLNl {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10%;
  grid-row: 2/3;
  grid-column: 1/2;
}
.FindUs_right__KUsVU {
  grid-row: 1/3;
  grid-column: 2/3;
  padding-left: 50px;
}

@media screen and (max-width: 1300px) {
  .FindUs_right__KUsVU {
    padding-top: 20px;
  }
}

@media screen and (max-width: 1200px) {
  .FindUs_wrapper__4NQTE {
    grid-template-columns: 70%;
    grid-template-rows: 0.4fr 0.8fr 0.8fr;
    padding-left: 28%;
  }
  .FindUs_title__x\\+uGp {
    grid-row: 1/2;
    grid-column: 1/2;
  }
  .FindUs_left__juLNl {
    grid-row: 3/4;
    grid-column: 1/2;
  }
  .FindUs_right__KUsVU {
    grid-row: 2/3;
    grid-column: 1/2;
    padding-top: 0px;
  }
}

@media screen and (max-width: 1100px) {
  .FindUs_h1__eBs6r {
    font-size: 31px;
  }
}

@media screen and (max-width: 1000px) {
  .FindUs_wrapper__4NQTE {
    grid-template-columns: 80%;
    padding-left: 23%;
  }
}

@media screen and (max-width: 900px) {
  .FindUs_wrapper__4NQTE {
    grid-template-rows: 0.4fr 0.7fr 0.8fr;
    grid-template-columns: 85%;
    padding-left: 24%;
  }
}

@media screen and (max-width: 770px) {
  .FindUs_wrapper__4NQTE {
    grid-template-columns: 95%;
    padding-left: 0%;
  }
  .FindUs_left__juLNl {
    width: 90%;
    padding-left: 50px;
    padding-top: 15px;
  }

  .FindUs_right__KUsVU {
    width: 100%;
    padding-top: 15px;
  }
}

@media screen and (max-width: 640px) {
  .FindUs_wrapper__4NQTE {
    grid-template-columns: 100%;
  }
  .FindUs_title__x\\+uGp {
    padding-left: 35px;
  }
}

@media screen and (max-width: 560px) {
  .FindUs_h1__eBs6r {
    font-size: 30px;
    width: 90%;
  }
  .FindUs_wrapper__4NQTE {
    padding: 20px 0;
  }
  .FindUs_right__KUsVU {
    padding-left: 30px;
  }
  .FindUs_left__juLNl {
    margin-left: 0;
  }
}

@media screen and (max-width: 450px) {
  .FindUs_h1__eBs6r {
    font-size: 30px;
    width: 95%;
  }
  .FindUs_title__x\\+uGp {
    padding-left: 25px;
  }
  .FindUs_right__KUsVU {
    padding-left: 5px;
  }
  .FindUs_left__juLNl {
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media screen and (max-width: 426px) {
  .FindUs_right__KUsVU {
    width: 100%;
    box-sizing: border-box;
  }
  .FindUs_wrapper__4NQTE {
    border-radius: 0;
  }
  .FindUs_position1__dcknP {
    position: absolute;
    width: 100%;
    left: 0;
    top: 5920px;
  }
  .FindUs_position0__NQS\\+- {
    position: absolute;
    width: 100%;
    left: 0;
  }
}

@media screen and (max-width: 376px) {
  .FindUs_position1__dcknP {
    top: 5975px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/FindUs/FindUs.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,qCAAqC;IACrC,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,OAAO;EACT;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".wrapper {\n  margin-bottom: 60px;\n  background-color: #f5f5f5;\n  border-radius: 16px;\n  display: grid;\n  grid-template-columns: 1.5fr 2.6fr;\n  grid-template-rows: 0.4fr 1fr;\n  padding: 50px;\n  padding-left: 120px;\n  box-sizing: border-box;\n}\n\n.title {\n  grid-column: 1/2;\n  grid-row: 1/2;\n  padding-left: 60px;\n}\n\n.h3 {\n  font-size: 20px;\n  color: rgb(188, 188, 188);\n}\n\n.h1 {\n  font-size: 36px;\n  font-weight: 800;\n  font-family: \"Lato\";\n}\n\n.left {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 10%;\n  grid-row: 2/3;\n  grid-column: 1/2;\n}\n.right {\n  grid-row: 1/3;\n  grid-column: 2/3;\n  padding-left: 50px;\n}\n\n@media screen and (max-width: 1300px) {\n  .right {\n    padding-top: 20px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .wrapper {\n    grid-template-columns: 70%;\n    grid-template-rows: 0.4fr 0.8fr 0.8fr;\n    padding-left: 28%;\n  }\n  .title {\n    grid-row: 1/2;\n    grid-column: 1/2;\n  }\n  .left {\n    grid-row: 3/4;\n    grid-column: 1/2;\n  }\n  .right {\n    grid-row: 2/3;\n    grid-column: 1/2;\n    padding-top: 0px;\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  .h1 {\n    font-size: 31px;\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .wrapper {\n    grid-template-columns: 80%;\n    padding-left: 23%;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .wrapper {\n    grid-template-rows: 0.4fr 0.7fr 0.8fr;\n    grid-template-columns: 85%;\n    padding-left: 24%;\n  }\n}\n\n@media screen and (max-width: 770px) {\n  .wrapper {\n    grid-template-columns: 95%;\n    padding-left: 0%;\n  }\n  .left {\n    width: 90%;\n    padding-left: 50px;\n    padding-top: 15px;\n  }\n\n  .right {\n    width: 100%;\n    padding-top: 15px;\n  }\n}\n\n@media screen and (max-width: 640px) {\n  .wrapper {\n    grid-template-columns: 100%;\n  }\n  .title {\n    padding-left: 35px;\n  }\n}\n\n@media screen and (max-width: 560px) {\n  .h1 {\n    font-size: 30px;\n    width: 90%;\n  }\n  .wrapper {\n    padding: 20px 0;\n  }\n  .right {\n    padding-left: 30px;\n  }\n  .left {\n    margin-left: 0;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .h1 {\n    font-size: 30px;\n    width: 95%;\n  }\n  .title {\n    padding-left: 25px;\n  }\n  .right {\n    padding-left: 5px;\n  }\n  .left {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n\n@media screen and (max-width: 426px) {\n  .right {\n    width: 100%;\n    box-sizing: border-box;\n  }\n  .wrapper {\n    border-radius: 0;\n  }\n  .position1 {\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 5920px;\n  }\n  .position0 {\n    position: absolute;\n    width: 100%;\n    left: 0;\n  }\n}\n\n@media screen and (max-width: 376px) {\n  .position1 {\n    top: 5975px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `FindUs_wrapper__4NQTE`,
	"title": `FindUs_title__x+uGp`,
	"h3": `FindUs_h3__uXsOu`,
	"h1": `FindUs_h1__eBs6r`,
	"left": `FindUs_left__juLNl`,
	"right": `FindUs_right__KUsVU`,
	"position1": `FindUs_position1__dcknP`,
	"position0": `FindUs_position0__NQS+-`
};
export default ___CSS_LOADER_EXPORT___;
